type StyledFormErrorProps = {
  errorMessage?: string | undefined;
};
export const StyledFormError: React.FC<StyledFormErrorProps> = ({ errorMessage }) => {
  return (
    <>
      {errorMessage && (
        <p
          className="
            text-[#d00101]
            my-2
            w-full
            font-bold
            min-h-[calc(1.5em + 1rem)]
            py-2 
            flex
            justify-center
            items-center
            bg-[#FBE3E1]
            border-y-2
            border-x-4
            border-[#d00101]
            rounded-lg
          "
          role="alert"
        >
          {errorMessage}
        </p>
      )}
    </>
  );
};
